import PropTypes from 'prop-types'

import { idPropType } from '~/src/Lib/PropTypes'
import { EMPTY_ARRAY, memoize } from '~/src/Lib/Utils'

export const optionShape = PropTypes.shape({
  color: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.shape({ id: idPropType })]),
  label: PropTypes.node.isRequired,
})

export const valueShape = PropTypes.oneOfType([
  PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]),
  PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string,
    ])
  )
])

export const isSelected = (option, props) => !!(
  props.multiple
    ? props.value && (props.value ?? EMPTY_ARRAY).find(s => props.equals(s, option.value))
    : props.value === option.value
)
export const getOnClick = memoize((option, props) => (
  props.multiple
    ? () => {
      props.onChange(
        isSelected(option, props)
          ? props.value.filter(value => value !== option.value)
          : [...(props.value ?? EMPTY_ARRAY), option.value]
      )
    }
    : () => props.onChange(option.value)
))
